//libs
import { useContext, useMemo, useState, useEffect } from 'react';

//components
import AlphabetFilter from './alphabet-filter';
import StoresList from './stores-list';
import ArrowDownYel from '../images/arrow-down-yel.svg';
import { StoresContext } from '../../../../App';
import CitiesColumns from './cities-columns';
import ActiveCity from './active-city';
import MapSection from './map-section';

//helpers
import { compareStrings } from '../../../../util/compareStrings';
import { buildColumnStructure } from '../helpers/buildColumnStructure';

//hooks
import { useColumnResize } from '../hooks/useColumnResize';

export default function CitiesListAlphabet(
    {
        fullStoresCounters
    }: {
        fullStoresCounters:  Map<string, number>,
    }
){
    const { 
        setLocationFilters,
        locationFilters,
        stores,
    } = useContext(StoresContext);
    const [selectedLetter, setSelectedLetter] = useState('');


    const setCityWithRegion = (city: string, region: string) => {
        setLocationFilters((values) => ({ ...values, city, region }));
    };

    const unsetCountry = () => {
        setLocationFilters((values) => ({ ...values, country: '', region: '', city: '' }));
    };

    const data = useMemo(() => {
        let storesCounter = 0;
        const citiesLetterMap = new Map<string, { city: string | null, region: string | null }[]>(); 

        for (const s of stores) {
            if(s.country === locationFilters.country) {
                storesCounter++;
            }

            if (
                s.city &&
                s.country === locationFilters.country                
            ) {

                if(locationFilters.region && s.region !== locationFilters.region){
                    continue;
                }

                const firstCityLetter = s.city.slice(0,1).toLocaleLowerCase();

                const citiesList = citiesLetterMap.get(firstCityLetter) ?? [];

                if(citiesList.findIndex((item) => item.city === s.city) === -1){
                    citiesList.push({ city: s.city, region: s.region });
                }

                citiesLetterMap.set(firstCityLetter, citiesList);
            }
        }

        return {
            storesCounter,
            letterMap: citiesLetterMap,
        };
    }, [stores, locationFilters]);

    const alphabetList = useMemo(() => {
        // Используем data.letterMap вместо allStores для генерации алфавита
        // чтобы показывать только буквы, для которых есть города в отфильтрованных данных
        return Array.from(data.letterMap.keys()).sort(compareStrings);
    }, [data.letterMap]);

    useEffect(() => {
        const alphabet = alphabetList;

        if(
            !selectedLetter || 
            alphabet.indexOf(selectedLetter) === -1
        ){
            setSelectedLetter(alphabet[0]);
        }
    }, [alphabetList, selectedLetter]);

    const [columnCount] = useColumnResize();

    const isShowCitiesFilter = Number(fullStoresCounters.get(locationFilters.country) ?? 0) > 10;
    const isSkipCityCheck = !isShowCitiesFilter;
    const countryTitleTemplate = locationFilters.region ? `${locationFilters.country}, ${locationFilters.region}` : locationFilters.country;
    
    return locationFilters.country ? (
        <>
            <div className="feature-filter-block cities-filter-block">
                <div className="cities-filter-block__header"> 
                    <div className="cities-filter-block__title" onClick={() => unsetCountry()}>
                        <img
                            src={ArrowDownYel}
                            alt="arrow-down"
                        />
                        {countryTitleTemplate}
                        <span className="cities-filter-block__counter">({data.storesCounter})</span>
                    </div>
                    {isShowCitiesFilter && (
                        <AlphabetFilter
                            list={alphabetList}
                            selectedLetter={selectedLetter}
                            selectLetter={(letter) => {
                                setSelectedLetter(letter);
                                setLocationFilters((values) => ({ ...values, city: '' }));
                            }}
                        />
                    )}
                </div>
                {isShowCitiesFilter && (
                    <div>
                        <div className="cities-filter-block__list cities-filter">
                            <div className="cities-filter__list cities-filter-list">
                                {
                                    !locationFilters.city ?
                                        <CitiesColumns columnsStructure={buildColumnStructure(data.letterMap.get(selectedLetter) ?? [], columnCount)} setCityWithRegion={setCityWithRegion} /> :
                                        <ActiveCity city={locationFilters.city} setCityWithRegion={setCityWithRegion} />
                                }
                            </div>
                        </div>
                    </div>
                )}
                <StoresList country={locationFilters.country} city={locationFilters.city} isSkipCityCheck={isSkipCityCheck}/>
                <MapSection />
            </div>
            
        </>
    ) : null;   
};
